import { Component, EventEmitter, Output } from '@angular/core';
import { IncassoForm } from '../../../form/incasso-form';
import { SezioneIncassiResponse } from '../../../models/dto/sezione-incassi-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Incasso } from '../../../models/incasso';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';


@Component({
    selector: 'div [incasso-form-edit]',
  templateUrl: '../../../form/incasso-form.html'
})

export class IncassiEditComponent extends IncassoForm {
  incasso: Incasso;
  sezione: SezioneIncassi;
  urlUpdate: string;
  urlReadSezioneControparti: string;

  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();

  ngOnInit() {
    this.setTitle('Modifica Incasso');
    this.isInserimento(false);
  }

  getIncasso() {
    return this.incasso;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getRequest(request: Incasso) {
    this.operationService.updateIncasso(this.urlUpdate, request, this.sezione.id).subscribe((response: any) => this.datiIncasso(response));
  }

  datiIncasso(response: SezioneIncassiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneIncassi, incasso: Incasso, idSezioneControparti: string, urlUpdate: string, urlReadSezioneControparti: string, fascicolo: FascicoloFull) {
    this.incasso = incasso;
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.readSezioneControparti(idSezioneControparti);
    this.createForm();
    this.populateSelect();
  }

}
